import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible"
import "./styles/reset.scss"
import "./styles/common.scss"
import '@/icons'
import VueWechatTitle from 'vue-wechat-title'
import toast from 'lib/component/vue/toast/toast.js'
import Stat from 'lib/lib/stat/Stat'
import 'utils/config'
import { DatetimePicker } from 'mint-ui';
import 'mint-ui/lib/style.css'
import { trackPlugin } from "@yxl/libs";
import allToApp from '@yxl/open-app'
import monitor from '@yxl/monitor'
window.monitor = monitor

Vue.component(DatetimePicker.name, DatetimePicker);

import vconsole from 'vconsole'
Vue.prototype.vconsole = new vconsole()
Vue.prototype.$stat = new Stat()
Vue.use(VueWechatTitle)
Vue.use(require('lib/component/vue/entry.js').default)
Vue.component('v-touch', require('components/v-touch-fake').default)
Vue.config.productionTip = false;
Vue.use(toast)

import { formatDecimal } from 'utils/utils'
// 处理万以上数据显示格式
Vue.filter('millionNum', function (value) {
  if (!value) return 0
  if (value < 10000) {
    return value
  } else {
    return formatDecimal(value/10000, 1) + '万'
  }
})

import { getPlatform } from 'lib/tools/getPlatform'
import Bridge from 'lib/lib/Bridge'
let $platform = getPlatform()
let { isYixinliApp } = $platform

if (isYixinliApp) {
  window.getAppToken = (obj) => {
    window.yxlAppToken = JSON.parse(obj).token || ''
  }
  new Bridge().call('getToken', { callbackName: 'getAppToken' })
}

Vue.use(trackPlugin)
Vue.use(allToApp)

// 全局变量
window.isYixinliApp = isYixinliApp
window.$platform = $platform

// 控制文字长度
Vue.filter('strLength', function (value, length) {
  if (!value) return ''
  if (value.length > length) {
    return value.substring(0, length) + '...'
  } else {
    return value
  }
})

if (process.env.NODE_ENV === 'production') {
  const {
    catchVueError,
    isSpiderRequest,
  } = require('lib/lib/catch.js')
  catchVueError(function(e) {
    console.log('catchError', e)
    if (isSpiderRequest()) return // 爬虫不上报
    window.monitor.stat(e)
  }, Vue)
}

window.liveVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
